const SET_CONFIG = 'SET_CONFIG';
const SET_ORIGIN_FIELD_INFOS = 'SET_ORIGIN_FIELD_INFOS';
const SET_PERIMETER_FIELD_INFOS = 'SET_PERIMETER_FIELD_INFOS';
const SET_SORT_FIELD = 'SET_SORT_FIELD';
const SET_SORT_DESC = 'SET_SORT_DESC';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_CONFIG,
  SET_ORIGIN_FIELD_INFOS,
  SET_PERIMETER_FIELD_INFOS,
  SET_SORT_FIELD,
  SET_SORT_DESC
};
